
import css from 'styled-jsx/css';

const styles = css.global`/* @styled-jsx=global */

.footer {
  display: grid;
  grid-template-columns: [content] 14fr;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  background-color: var(--paper);

  /*
   * These are global styles.
   * While BRP is not fully released some pages might have old styles,
   * but the footer has to have new styles all the time.
   * TODO: Cleanup BRP 2022. Remove these lines after BRP is fully released.
   */
  font-size: 16px;
  font-family: $fontTTNormsPro;
  font-weight: 400;

  @include media-query(desktopLg) {
    padding: 0;
    margin: 0 auto;
  }
}

.content-wrapper {
  grid-area: content;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;
  max-width: $container-max-width;
  margin: 40px auto;

  @include media-query(mobile) {
    grid-gap: 0;
  }
  @include media-query(tablet) {
    grid-template-columns: 2fr 1fr;
    grid-column-gap: map-get($grid-gap-map, tablet);
  }

  @include media-query(desktop) {
    grid-template-columns: 3fr 1fr;
    grid-column-gap: map-get($grid-gap-map, desktop);
  }
}

.primary-links {
  column-count: 1;
  column-gap: 10px;

  @media (min-width: 25em) {
    column-count: 2;
  }
  @include media-query(laptop) {
    column-count: 3;
  }
  @media (min-width: 1200px) {
    column-count: 4;
    column-gap: 20px;
  }

  &__list-item {
    padding-bottom: 36px;
    width: 100%;
    break-inside: avoid;
  }
}

// Prevent column items wrapping for Firefox.
@supports (page-break-inside: avoid) {
  .primary-links__list-item {
    page-break-inside: avoid;
    overflow: hidden;
  }
}

.secondary-links {
  grid-row-start: 4;
  display: flex;
  padding: 20px 0;
  margin-left: -0.938rem;
  @include media-query(mobile) {
    flex-wrap: wrap;
    grid-row-gap: 1.563rem;
    padding-bottom: 2.5rem;
    margin-left: 0;
    grid-gap: 1.2rem;
  }

  &__list-item {
    font-weight: 700;
  }

  &__link {
    @include focusable($inlineOffset: 0, $blockOffset: 0);
    color: $slate;
    text-decoration: none;
    padding: 0.938rem;

    @include media-query(mobile) {
      padding: 0;
    }

    &:hover,
    &:focus {
      outline: none;
      text-decoration: underline;
    }
  }
}

.extra-content {
  grid-row-start: 2;
  grid-column: span 2;
}

.blog-content {
  grid-row-start: 3;
  border-top: 1px solid $gray;
  border-bottom: 1px solid $gray;
  padding: 20px 0;

  @include media-query(tablet) {
    grid-row-start: 1;
    grid-column-start: 2;
    border: none;
    padding-top: 0;
  }
}

.footer__link {
  @include focusable;
  display: block;
  padding: 6px 0;
  color: $slate;
  text-decoration: none;
  position: relative;
  outline: none;

  &:hover {
    text-decoration: underline;
  }

  &--blog {
    margin-top: 10px;
    > a {
      @include focusable;
    }
    &:hover {
      text-decoration: none;
    }
  }
}

@include media-query(tablet) {
  footer {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@include media-query(desktop) {
  footer {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
`;

export default styles;